var map = {
	"./acontroller_notselected.png": 6596,
	"./additional_controller_notselected.png": 5607,
	"./battery_notselected.png": 1354,
	"./bill_notselected.png": 8332,
	"./box_notselected.png": 870,
	"./button_notselected.png": 5143,
	"./cameraglass_notselected.png": 5682,
	"./cd_notselected.png": 4838,
	"./charger_notselected.png": 7023,
	"./chargingport_notselected.png": 9019,
	"./controller_notselected.png": 2152,
	"./fingertouch_notselected.png": 5557,
	"./frontcamera_notselected.png": 9289,
	"./hdmi_notselected.png": 2525,
	"./keyboard_notselected.png": 8128,
	"./lan_notselected.png": 4052,
	"./microphone_notselected.png": 6583,
	"./mouse_notselected.png": 4652,
	"./original_controllers_notselected.png": 36,
	"./powerbutton_notselected.png": 6938,
	"./proximitysensor_notselected.png": 8072,
	"./rearcamera_notselected.png": 6384,
	"./remote_notselected.png": 4369,
	"./simcard_notselected.png": 6594,
	"./speaker_notselected.png": 7930,
	"./speakerbutton_notselected.png": 1750,
	"./touchpad_notselected.png": 1807,
	"./trackpad_notselected.png": 8263,
	"./usb_notselected.png": 9639,
	"./vibrator_notselected.png": 9608,
	"./volume_notselected.png": 1165,
	"./webcamera_notselected.png": 262,
	"./wifibluetooth_notselected.png": 8026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6878;